import { Environments } from 'src/constants/Environment';
import { envENVIRONMENT } from 'src/env/envENVIRONMENT';

export function isProductionEnvironment(): boolean {
    return envENVIRONMENT() === Environments.PROD;
}
